import { ReactElement, useEffect, useState } from "react";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType, IPublicClientApplication } from "@azure/msal-browser";
import { getMsalInstance } from "./services/auth/msalInstance";
import { appLoginRequestAzure } from "./services/auth/msalConfigAzureAd";
import { appLoginRequestAdfs } from "./services/auth/msalConfigAdfs";
import Logout from "./pages/External";
import { AuthContextProvider } from "./context/AuthContext";

const AuthInitializer = (): ReactElement => {
  const [msalInstance, setMsalInstance] = useState<IPublicClientApplication | null>(null);
  const [appLoginRequest, setAppLoginRequest] = useState<any>(null);
  const [loggedUser, setLoggedUser] = useState<boolean>(false);

  useEffect(() => {
    const init = async () => {
      const instance = await getMsalInstance();
      setMsalInstance(instance);

      const provider = window.localStorage.getItem("AUTH_PROVIDER");
      const loginRequest = provider === "Adfs" ? appLoginRequestAdfs : appLoginRequestAzure;
      setAppLoginRequest(loginRequest);

      const hasAccount = instance.getAllAccounts().length > 0;

      const shouldLogin = window.localStorage.getItem("SHOULD_LOGIN");
      setLoggedUser(hasAccount || !!shouldLogin);
    };

    void init();
  }, []);

  if (!msalInstance || !appLoginRequest) return <></>;

  return loggedUser || window.location.pathname === "/" ? (
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <AuthContextProvider>
          <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={appLoginRequest}>
            <App />
          </MsalAuthenticationTemplate>
        </AuthContextProvider>
      </MsalProvider>
    </BrowserRouter>
  ) : (
    <Logout />
  );
};

export default AuthInitializer;
